import { api } from '../api';
import type {
  SendMfaCodeProps,
  SendMfaCodeResponse,
  VerifyMfaCodeProps,
  VerifyMfaCodeResponse,
} from './mfa.types';

export const mfaUrls = {
  sendCode: ({ isKiosk }: Pick<SendMfaCodeProps, 'isKiosk'>) =>
    isKiosk ? '/kiosk/users/multifactor_codes' : '/users/multifactor_codes',
  verifyCode: ({ isKiosk }: Pick<VerifyMfaCodeProps, 'isKiosk'>) =>
    isKiosk
      ? '/kiosk/users/multifactor_codes/verify'
      : '/users/multifactor_codes/verify',
};

export const sendMfaCode = async ({
  isKiosk = false,
  jwt,
  newPhone,
}: SendMfaCodeProps): Promise<SendMfaCodeResponse> => {
  const url = mfaUrls.sendCode({ isKiosk });

  await api.post(url, newPhone ? { new_phone: newPhone } : {}, jwt);

  return { success: true };
};

export const verifyMfaCode = async ({
  code,
  isKiosk = false,
  jwt,
}: VerifyMfaCodeProps): Promise<VerifyMfaCodeResponse> => {
  const url = mfaUrls.verifyCode({ isKiosk });

  return api.post<VerifyMfaCodeResponse>(url, { code }, jwt);
};
